import React, { Component } from "react";
import { Modal, Form, Input, Select, DatePicker } from "antd";
import moment from "moment";
import http from "../../../axios/http";
import server from "../../../axios/server";
const { confirm } = Modal;
const FormItem = Form.Item;

class PlateNoCardEditForm extends Component {
  constructor(props) {
    super(props);
    this.state = { parkZones: [], members: [] };
  }
  onStartDateChange = (item, val) => {
    this.props.editData.startDate = val;
  };
  onDateChange = (item, val) => {
    this.props.editData.expireDate = val;
  };

  loadBarrierMember() {
    http.post({
      url: "/barrier/plateNoCard/allMembers",
      success: (res) => {
        this.setState({ members: res });
      },
    });
  }

  loadAllZone = () => {
    http.post({
      url: "/barrier/parkgate/allZone",
      data: {},
      success: (res) => {
        this.setState({ parkZones: res });
      },
    });
  };
  componentWillMount() {
    this.loadBarrierMember();
    this.loadAllZone();
  }
  memberCodeChange = (val, option) => {
    const { editData } = this.props;
    editData.memberCode = val;
    if (val) {
      editData.memberName = option.props.children;
    } else {
      editData.memberName = "";
    }
  };
  save = () => {
    const { editData } = this.props;
    if (editData.id) {
      confirm({
        title: '确认修改该条白名单记录?',
        content: '修改需重新提交并发起审核,请谨慎操作!',
        cancelText: '否',
        okText: '是',
        onOk:()=> {
          this.edit();
        },
        onCancel() {},
      });

    } else {
      this.add();
    }
  };
  add = ()=> {
    const { editData, form } = this.props;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      values["state"] = 1;
      values["expireDate"] = editData.expireDate;
      values["startDate"] = editData.startDate;
      values["useZone"] = values.useZoneArr.join(",");
      delete values.useZoneArr;
      http.post({
        url: "/barrier/plateNoCard/save",
        data: values,
        success: (res) => {
          debugger
          http.post({
            url:server.mallServerUrl+"/externalApi/barrier/updatePlateNoWLCache",
            data: { plateNo: values.plateNo },
            success: (res) => {
              console.log("mallapi白名单缓存刷新成功");
            },
          });
          this.props.successCallback(this.props.queryData);
          this.props.onCancel();
        },
      });
    });
  };
  edit = ()=> {
    const { editData, form } = this.props;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      values["id"] = editData.id;
      values["state"] = 1;
      values["expireDate"] = editData.expireDate;
      values["startDate"] = editData.startDate;
      values["useZone"] = values.useZoneArr.join(",");
      delete values.useZoneArr;
      http.post({
        url: "/barrier/plateNoCard/save",
        data: values,
        success: (res) => {
          http.post({
            url:server.mallServerUrl+"/externalApi/barrier/updatePlateNoWLCache",
            data: { plateNo: values.plateNo },
            success: (res) => {
              console.log("mallapi白名单缓存刷新成功");
            },
          });
          this.props.successCallback(this.props.queryData);
          this.props.onCancel();
        },
      });
    });
  };

  render() {
    const { visible, onCancel, form, editData } = this.props;
    const { getFieldDecorator } = form;
    const { parkZones, members } = this.state;
    return (
      <Modal
        visible={visible}
        title="月卡车编辑"
        okText="保存"
        cancelText="取消"
        maskClosable={false}
        onCancel={onCancel}
        onOk={this.save}
        afterClose={() => {
          this.props.form.resetFields();
        }}
      >
        <Form
          layout="vertical"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 15 }}
        >
          <FormItem label="车牌号：">
            {getFieldDecorator("plateNo", {
              rules: [
                { required: true, message: "请输入车牌号!" },
                { max: 10, message: "最多只能输入10个字符！" },
              ],
              initialValue: editData.plateNo,
            })(<Input />)}
          </FormItem>
          <FormItem label="选择商户：">
            {getFieldDecorator("memberCode", {
              rules: [{ required: true, message: "请选择商户" }],
              initialValue: editData.memberCode,
            })(
              <Select onChange={this.memberCodeChange}>
                {/* <Select.Option value="">手工录入</Select.Option> */}
                {members &&
                  members.map((item, index) => (
                    <Select.Option key={item.id} value={item.code}>
                      {item.name}
                    </Select.Option>
                  ))}
              </Select>
            )}
          </FormItem>
          {/* <FormItem label="商户名：">
            {getFieldDecorator("memberName", {
              rules: [{ max: 10, message: "最多只能输入10个字符！" }],
              initialValue: editData.memberName,
            })(<Input disabled={!!editData.memberCode} />)}
          </FormItem> */}
          <FormItem label="姓名：">
            {getFieldDecorator("name", {
              rules: [{ max: 10, message: "最多只能输入10个字符！" }],
              initialValue: editData.name,
            })(<Input />)}
          </FormItem>
          <FormItem label="电话：">
            {getFieldDecorator("telephone", {
              rules: [{ max: 20, message: "最多只能输入20个字符！" }],
              initialValue: editData.telephone,
            })(<Input />)}
          </FormItem>
          <FormItem label="白名单类型：">
            {getFieldDecorator("type", {
              rules: [{ required: true, message: "请选择类型" }],
              initialValue: editData.type,
            })(
                <Select >
                  <Select.Option value={0}>门店</Select.Option>
                  <Select.Option value={1}>缴费</Select.Option>
                  <Select.Option value={2}>其他</Select.Option>
                </Select>
            )}
          </FormItem>
          <FormItem label="缴费金额：">
            {getFieldDecorator("paymentAmount", {
              rules: [
                  { required: false, message: "请输入缴费金额！" },
                {validator: (rule, value, callback) => {
                  if (value === "" || value === undefined || value === null) {
                    callback(); // 如果允许为空，可以不校验
                    return;
                  }
                  // 检查是否为数字
                  if (isNaN(Number(value))) {
                    callback("请输入有效的数字！");
                    return;
                  }
                  // 检查是否为负数
                  if (Number(value) < 0) {
                    callback("金额不能为负数！");
                    return;
                  }
                  // 检查小数位数（最多2位）
                  const decimalPart = value.toString().split(".")[1];
                  if (decimalPart && decimalPart.length > 2) {
                    callback("金额最多保留2位小数！");
                    return;
                  }
                  callback(); // 验证通过
                },
              }],
              initialValue: editData.paymentAmount,
            })(<Input />)}
          </FormItem>
          <FormItem label="起始日期：">
            {getFieldDecorator("startDate", {
              rules: [{ required: true, message: "请输入起始日期" }],
              initialValue: moment(editData.startDate, "YYYY-MM-DD"),
            })(
                <DatePicker onChange={this.onStartDateChange}
                            placeholder="起始日期"
                            disabledDate={(current) => {
                              const expireDate = this.props.form.getFieldValue("expireDate");
                              // 如果存在有效期至，禁用晚于它前一天的日期
                              return expireDate && current && current >= expireDate.clone().startOf("day");
                            }}
                />
            )}
          </FormItem>
          <FormItem label="有效期至：">
            {getFieldDecorator("expireDate", {
              rules: [{ required: true, message: "请输入有效期" }],
              initialValue: moment(editData.expireDate, "YYYY-MM-DD"),
            })(
              <DatePicker onChange={this.onDateChange}
                          placeholder="有效期至"
                          disabledDate={(current) => {
                            const startDate = this.props.form.getFieldValue("startDate");
                            // 如果有起始日期，则禁用小于等于起始日期的日期
                            return startDate && current && current <= startDate.clone().endOf("day");
              }} />
            )}
          </FormItem>
          <FormItem label="生效场地：">
            {getFieldDecorator("useZoneArr", {
              initialValue: editData.useZoneArr,
            })(
              <Select mode="multiple">
                {parkZones &&
                  parkZones.map((item, index) => (
                    <Select.Option key={item.id} value={item.code}>
                      {item.name}
                    </Select.Option>
                  ))}
              </Select>
            )}
          </FormItem>
          <FormItem label="备注">
            {getFieldDecorator("remark", {
              rules: [{ max: 20, message: "最多只能输入20个字符！" }],
              initialValue: editData.remark,
            })(<Input />)}
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

const PlateNoCardEdit = Form.create()(PlateNoCardEditForm);

export default PlateNoCardEdit;
